import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const PaperFreeMonitoringPostReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default PaperFreeMonitoringPostReport;

PaperFreeMonitoringPostReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  totalColumns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
